<template>
  <div>
    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __("Export jobs overview") }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div class="max-w-5xl mx-auto">
          <div class="mt-10 mx-auto max-w-sm w-full">
            <div class="flex-1 w-full mb-4">
              <label class="block text-gray-400 mb-2">{{ __('Start date') }}</label>
              <VueDatePicker v-model="form.startDate" color="#253746" :visible-years-number="100" :no-input="true" :locale="datePickerLocale"/>
            </div>
            <div class="flex-1 w-full mb-4">
              <label class="block text-gray-400 mb-2">{{ __('End date') }}</label>
              <VueDatePicker v-model="form.endDate" color="#253746" :visible-years-number="100" :no-input="true" :locale="datePickerLocale"/>
            </div>

            <div>
              <a class="h-10 inline-flex items-center justify-center text-xl px-10 rounded-lg text-coral-400 border-2 border-coral-400 w-full" :href="exportLink">Export</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import JobMenu from '../Jobs/JobMenu'
import { format } from 'date-fns'

export default {
  layout: Layout,
  props: {},
  components: {
    Layout,
    JobMenu,
    TextareaInput,
  },
  data() {
    return {
      datePickerLocale: window.datePickerLocale,
      form: {
        startDate: format(new Date(), 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd'),
      },
    }
  },
  computed: {
    exportLink() {
      return this.route('jobReports.showOverview', { startDate: this.form.startDate, endDate: this.form.endDate })
    },
  },
}
</script>
